/* One scroll-driven detail reveal; native document scrolling remains in control. */
(() => {
  const root = document.documentElement;
  const hero = document.querySelector('.showcase-hero');
  const process = document.querySelector('.process-showcase');
  const header = document.querySelector('.site-header');
  if (!hero || !process || !header) return;

  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const heroControls = [...hero.querySelectorAll('a[href], button')].map(control => ({
    control,
    originalTabindex: control.getAttribute('tabindex')
  }));
  let frame = 0;
  let enabled = null;
  let lastProgress = '';
  let obscured = null;

  function setObscured(next) {
    if (next === obscured) return;
    obscured = next;
    hero.dataset.obscured = String(next);
    heroControls.forEach(({control, originalTabindex}) => {
      if (next) control.setAttribute('tabindex', '-1');
      else if (originalTabindex === null) control.removeAttribute('tabindex');
      else control.setAttribute('tabindex', originalTabindex);
    });
    document.dispatchEvent(new CustomEvent('atelier:visibility', {detail: {obscured: next}}));
  }

  function update() {
    frame = 0;
    if (document.hidden) return;
    const viewportHeight = window.innerHeight;
    const nextEnabled = !preference.matches && viewportHeight > 700;
    if (nextEnabled !== enabled) {
      enabled = nextEnabled;
      root.classList.toggle('atelier-motion', enabled);
    }

    let progress = '1';
    let covered = false;
    if (enabled) {
      const headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
      const processTop = process.getBoundingClientRect().top;
      const travel = Math.max(1, viewportHeight - headerBottom);
      progress = Math.min(1, Math.max(0, (viewportHeight - processTop) / travel)).toFixed(4);
      covered = processTop <= headerBottom + 8;
    }
    if (progress !== lastProgress) {
      process.style.setProperty('--detail-progress', progress);
      lastProgress = progress;
    }
    setObscured(covered);
  }

  function schedule() {
    if (!frame && !document.hidden) frame = window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('load', schedule, {once: true});
  window.addEventListener('hashchange', schedule);
  window.addEventListener('pageshow', schedule);
  preference.addEventListener('change', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && frame) {
      window.cancelAnimationFrame(frame);
      frame = 0;
    } else schedule();
  });
  document.fonts?.ready.then(schedule);
  schedule();
})();
